import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle2, Eye, EyeOff } from "lucide-react";
import { Brand, Field } from "@/components/common";
import { api, errMsg } from "@/lib/api";

const FIELDS = [
  ["company", "Nama perusahaan / pemilik", "text", "PT Contoh Logistik"],
  ["name", "Nama lengkap", "text", "Nama Anda"],
  ["email", "Email", "email", "nama@perusahaan.com"],
  ["phone", "Nomor telepon (opsional)", "tel", "0812..."],
  ["password", "Password (min 8 karakter)", "password", "••••••••"],
  ["confirm", "Ulangi password", "password", "••••••••"],
];

export default function Register() {
  const [f, setF] = useState({ company: "", name: "", email: "", phone: "", password: "", confirm: "" });
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (f.password.length < 8) return setErr("Password minimal 8 karakter");
    if (f.password !== f.confirm) return setErr("Konfirmasi password tidak sama");
    setBusy(true);
    try {
      const { confirm, ...body } = f;
      await api.post("/auth/register", { ...body, phone: body.phone || null });
      setDone(true);
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 py-12">
      <div className="w-full max-w-md gt-rise">
        <Brand className="mb-10" />
        {done ? (
          <div className="gt-card p-6 text-center" data-testid="register-success">
            <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-500" />
            <h2 className="mt-3 text-xl font-extrabold">Pendaftaran berhasil</h2>
            <p className="mt-2 text-sm text-muted-foreground">Akun Anda sedang menunggu persetujuan admin GLAZY TRACKER. Kami akan mengirim email ke {f.email} begitu akun disetujui.</p>
            <Link to="/login" className="mt-5 inline-block rounded-xl bg-primary px-5 py-2.5 text-sm font-bold text-primary-foreground" data-testid="register-to-login">Kembali ke halaman masuk</Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="register-form">
            <div className="gt-eyebrow mb-3">Daftar akun baru</div>
            <h2 className="text-3xl font-extrabold tracking-tight">Mulai lacak armada Anda</h2>
            <p className="mt-2 text-sm text-muted-foreground">Daftar dengan email. Akun aktif setelah diverifikasi admin, lalu perangkat GPS (IMEI) dipasangkan ke akun Anda.</p>
            <div className="mt-7 space-y-3.5">
              {FIELDS.map(([k, label, type, ph]) => {
                const isPassword = k === "password" || k === "confirm";
                const visible = k === "password" ? showPassword : showConfirm;
                return (
                  <Field key={k} label={label}>
                    <div className="relative">
                      <input
                        type={isPassword ? (visible ? "text" : "password") : type === "email" ? "email" : type}
                        name={k === "email" ? "email" : k === "password" ? "new-password" : k === "confirm" ? "confirm-password" : k}
                        autoComplete={k === "email" ? "email" : k === "password" ? "new-password" : k === "confirm" ? "new-password" : "off"}
                        inputMode={type === "email" ? "email" : undefined}
                        minLength={k === "password" || k === "confirm" ? 8 : undefined}
                        required={k !== "phone"}
                        value={f[k]}
                        onChange={(e) => setF({ ...f, [k]: e.target.value })}
                        placeholder={ph}
                        className={`gt-input h-11 ${isPassword ? "pr-12" : ""}`}
                        data-testid={`register-${k}-input`}
                      />
                      {isPassword && (
                        <button
                          type="button"
                          onClick={() => k === "password" ? setShowPassword(!showPassword) : setShowConfirm(!showConfirm)}
                          className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
                          aria-label={visible ? "Sembunyikan password" : "Tampilkan password"}
                        >
                          {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                        </button>
                      )}
                    </div>
                  </Field>
                );
              })}
              {err && <div className="rounded-xl border border-red-500/40 bg-red-500/10 px-3 py-2 text-sm text-red-500" data-testid="register-error">{err}</div>}
              <button disabled={busy} className="h-12 w-full rounded-xl bg-primary font-bold text-primary-foreground transition-opacity hover:opacity-95 disabled:opacity-60" data-testid="register-submit-button">
                {busy ? "Mendaftarkan..." : "Daftar"}
              </button>
            </div>
            <Link to="/login" className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-muted-foreground hover:text-foreground" data-testid="register-back-login"><ArrowLeft className="h-4 w-4" /> Sudah punya akun? Masuk</Link>
          </form>
        )}
      </div>
    </div>
  );
}
